import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseKey);
export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl as string, supabaseKey as string)
  : null;

// Database types (you'll need to generate these from your Supabase schema)
export interface Database {
  public: {
    Tables: {
      flashcards: {
        Row: {
          id: string;
          topic: string;
          question: string;
          answer: string;
          category: string;
          difficulty: 'easy' | 'medium' | 'hard';
          tags: string[];
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          topic: string;
          question: string;
          answer: string;
          category: string;
          difficulty?: 'easy' | 'medium' | 'hard';
          tags?: string[];
          created_at?: string;
          updated_at?: string;
        };
        Update: {
          id?: string;
          topic?: string;
          question?: string;
          answer?: string;
          category?: string;
          difficulty?: 'easy' | 'medium' | 'hard';
          tags?: string[];
          created_at?: string;
          updated_at?: string;
        };
      };
      user_progress: {
        Row: {
          user_id: string;
          flashcard_id: string;
          ease_factor: number;
          interval: number;
          repetitions: number;
          next_review_date: string;
          last_reviewed: string;
          quality: number;
          times_correct: number;
          times_incorrect: number;
        };
        Insert: {
          user_id: string;
          flashcard_id: string;
          ease_factor?: number;
          interval?: number;
          repetitions?: number;
          next_review_date?: string;
          last_reviewed?: string;
          quality?: number;
          times_correct?: number;
          times_incorrect?: number;
        };
        Update: {
          user_id?: string;
          flashcard_id?: string;
          ease_factor?: number;
          interval?: number;
          repetitions?: number;
          next_review_date?: string;
          last_reviewed?: string;
          quality?: number;
          times_correct?: number;
          times_incorrect?: number;
        };
      };
      study_sessions: {
        Row: {
          id: string;
          user_id: string;
          start_time: string;
          end_time?: string;
          flashcards_studied: number;
          correct_answers: number;
          total_time: number;
          technique: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          start_time?: string;
          end_time?: string;
          flashcards_studied?: number;
          correct_answers?: number;
          total_time?: number;
          technique: string;
        };
        Update: {
          id?: string;
          user_id?: string;
          start_time?: string;
          end_time?: string;
          flashcards_studied?: number;
          correct_answers?: number;
          total_time?: number;
          technique?: string;
        };
      };
      users: {
        Row: {
          id: string;
          email: string;
          created_at: string;
          settings: any;
        };
        Insert: {
          id: string;
          email: string;
          created_at?: string;
          settings?: any;
        };
        Update: {
          id?: string;
          email?: string;
          created_at?: string;
          settings?: any;
        };
      };
    };
    Views: {
      [_ in never]: never;
    };
    Functions: {
      [_ in never]: never;
    };
    Enums: {
      [_ in never]: never;
    };
  };
}
